export const SET_LOADING = 'SET_LOADING';
export const SET_LISTINGS = 'SET_LISTINGS';
